/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IWizardOrderTemplateReducer } from './reducer';

export enum EWizardOrderTemplateSteps {
    TemplateSelectionDataStep = 'TemplateSelectionDataStep',
    TemplateParametersConfirmStep = 'TemplateParametersConfirmStep',
}

export const initWizardOrderTemplateState: IWizardOrderTemplateReducer = {
    validation: {
        isValid: true,
        error: '',
    },
};

/*
 * -------------------------------------------
 *           Common Wizard Actions
 * -------------------------------------------
 */

export const WIZARD_ORDER_TEMPLATE_HANDLE_NEXT =
    '@@b2b_portal_ui/wizardOrderTemplate/WIZARD_ORDER_TEMPLATE_HANDLE_NEXT';

export const WIZARD_ORDER_TEMPLATE_SET_STEP_VALID =
    '@@b2b_portal_ui/wizardOrderTemplate/WIZARD_ORDER_TEMPLATE_SET_STEP_VALID';

export const WIZARD_ORDER_TEMPLATE_SET_PARAMS = '@@b2b_portal_ui/wizardOrderTemplate/WIZARD_ORDER_TEMPLATE_SET_PARAMS';
